import { render } from "./OrderSuccess.vue?vue&type=template&id=6a14deb5&scoped=true"
import script from "./OrderSuccess.vue?vue&type=script&lang=js"
export * from "./OrderSuccess.vue?vue&type=script&lang=js"

import "./OrderSuccess.vue?vue&type=style&index=0&id=6a14deb5&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a14deb5"]])

export default __exports__